<script lang="ts">
  import { app } from './appState.svelte';
  import Library from './Library.svelte';
  import Editor from './Editor.svelte';
  import TrashView from './TrashView.svelte';
  import Toast from './Toast.svelte';

  const ready = app.init();
</script>

{#await ready}
  <div class="boot"></div>
{:then}
  {#if app.route.screen === 'library'}
    <Library />
  {:else if app.route.screen === 'editor'}
    <Editor notebookId={app.route.notebookId} pageId={app.route.pageId} />
  {:else if app.route.screen === 'trash'}
    <TrashView />
  {/if}
  <Toast />
{:catch}
  <div class="boot-error"><p>Couldn't open the notes database. Try reloading.</p></div>
{/await}

<style>
  .boot { height: 100vh; background: var(--paper); }
  .boot-error { height: 100vh; background: var(--paper); color: var(--ink-primary); display: grid; place-items: center; text-align: center; padding: 24px; }
</style>
